import { PBCC_PREMIUM } from '../config/siteMode.js'

// Flight 12 is a SCRAMBLE, not a match-play bracket. It must render as the pro
// shop's physical score table (Team · Rd 1 / Rd 2 / Rd 3) on EVERY surface a
// flight appears — bracket board, Live Leaderboard, TV views, public hub, admin
// — and never as fake "VS" match pairings. This is a SELF-CONTAINED scoreboard
// card (its own deep-green panel + gold frame) so it reads correctly on any
// background: the green boards, the white public hub, and phones. Data lives at
// tournaments/{tid}/flights/{fid}/scramble = { rounds, rows:[{name,teamId,rd1..}]}.
// Pass `flightName` where the surrounding chrome doesn't already show it (the
// bracket tile already prints the flight name, so it omits the prop).
const PANEL = PBCC_PREMIUM ? '#0E281D' : '#123D26'   // deep green panel
const HEADROW = '#0A2016'                             // darker green header strip
const GOLD = PBCC_PREMIUM ? '#C2A24E' : '#D8C77E'
const CREAM = '#F7F2E6'
const GREEN = '#123D26'
const WD_RED = '#B23A3A'
const COL = 100   // fixed width per score column, right next to the names

export default function ScrambleTable({ data, flightName }) {
  const rounds = Number(data?.rounds) || 3
  const rows = Array.isArray(data?.rows) ? data.rows : []
  const cols = Array.from({ length: rounds }, (_, i) => i + 1)
  const show = (v) => (v == null || v === '' ? '—' : String(v))

  return (
    // Center the card both ways so it never floats to the edges or leaves a big
    // empty area below on a full-screen flight tile; on shorter parents (grid
    // cells, hub) it just sizes to its content.
    <div className="w-full h-full flex items-center justify-center p-2">
      <div style={{
        width: '100%', maxWidth: 760, backgroundColor: PANEL,
        border: `2px solid ${GOLD}`, borderRadius: 14, padding: '14px 16px 16px',
        boxShadow: '0 6px 18px rgba(0,0,0,0.28)', fontFamily: 'Marcellus, Georgia, serif',
      }}>
        {flightName ? (
          <div className="text-center" style={{ color: GOLD, fontSize: '26px', fontWeight: 800, lineHeight: 1.1 }}>
            {flightName}
          </div>
        ) : null}
        <div className="text-center uppercase mb-2"
             style={{ color: GOLD, fontSize: '18px', fontWeight: 700, letterSpacing: '0.28em', marginTop: flightName ? 2 : 0 }}>
          Scramble
        </div>
        <div className="rounded-lg overflow-hidden" style={{ border: `1px solid ${GOLD}` }}>
          {/* header row */}
          <div className="flex items-center" style={{ backgroundColor: HEADROW }}>
            <span className="px-5 py-2 uppercase" style={{ flex: '1 1 auto', color: GOLD, fontSize: '14px', fontWeight: 700, letterSpacing: '0.08em' }}>Team</span>
            {cols.map((r) => (
              <span key={r} className="text-center py-2 uppercase" style={{ width: COL, flex: `0 0 ${COL}px`, color: GOLD, fontSize: '14px', fontWeight: 700, letterSpacing: '0.06em' }}>Rd {r}</span>
            ))}
          </div>
          {/* team rows — big, comfortable height */}
          {rows.map((row, i) => (
            <div key={i} className="flex items-center" style={{ backgroundColor: CREAM, borderTop: `1px solid ${GOLD}55`, minHeight: 50 }}>
              <span className="px-5 truncate" style={{ flex: '1 1 auto', color: GREEN, fontSize: '24px', fontWeight: 700, fontFamily: 'Georgia, serif' }}>
                {row?.name || '—'}
              </span>
              {cols.map((r) => {
                const v = row?.[`rd${r}`]
                const wd = String(v).toUpperCase() === 'WD'
                return (
                  <span key={r} className="text-center" style={{ width: COL, flex: `0 0 ${COL}px`, color: wd ? WD_RED : GREEN, fontSize: '23px', fontWeight: wd ? 900 : 700, fontFamily: 'Georgia, serif' }}>
                    {show(v)}
                  </span>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
